import {DOM} from '../core/dom';

export namespace CompaniesMatching {
  export function onload(): void {
    DOM.onIdClick('companies-matching-reach-out-btn', () => DOM.redirectTo('/contact.html?mode=company'));
  }
}